import Vue from 'vue';
import Vuex from 'vuex'
Vue.use(Vuex)

const emptyPack = {
  id:'empty',
  layers:[]
}

const state = () => {
  return {
    isAyoba: false,
    loggedIn: false,
    user:{id:'anonymous', anonymous: true, username:'anonymous'},
    jwtToken: '',
    fingerprint: true,
    templateMode: false,
    isAnimationEnabled: true,
    viewingTemplateItem:undefined,
    draggingKeepRatio:true,
    renderTools:{},
    holderData:{},
    selectionsData:[],
    isAdvancedMode:false,
    globalPlayingPaused:false,
    noTransformsAdded: true,
    drawAnchorForTransformId: '',
    postsViewed:0,
    canInstallApp:false,
    viewingPostId:{
      hot:'',
      new:''
    },
    viewPosts:{
      hot:{
        from:0,
        size:20
      },
      new:{
        from:0,
        size:20
      }
    },
    stickerSearch:'',
    videoSearch:'',

    selectedCreateMode:'template',
    selectedAddMode:'image',
    selectedPack:emptyPack,
    emptyPack,
    currentActivityId:'',
    recentlyUsedAssets:[],
    myPostedPostsIds:[],
    justPosted:true,

    fromHot:'',
    fromNew:''
  }

}

const getters = {
  loggedIn(state) {
    return state.loggedIn;
  },
  jwtToken(state) {
    return state.jwtToken;
  }

}

const mutations = {
  loggedIn(state) {
    state.loggedIn = true;
  },
  setUser(state, user) {
    state.user = user;
  },
  setFingerprint(state, fingerprint) {
    state.fingerprint = fingerprint;
  },
  setIsAyoba(state, isAyoba) {
    state.isAyoba = isAyoba;
    /*
    isAyoba() {
      return !!this.$route.query.jid;
    },
    */
  },
  setAnimationEnabled(state, enabled) {
    state.isAnimationEnabled = enabled;
  },
  setDraggingKeepRatio(state, keepRatio) {
    state.draggingKeepRatio = keepRatio;
  },
  setViewingTemplateItem(state, id) {
    state.viewingTemplateItem = id;
  },
  setTemplateMode(state, templateMode) {
    state.templateMode = templateMode;
  },
  setJwtToken(state, jwtToken) {
    state.jwtToken = jwtToken;
  },
  setRenderTools(state, renderTools) {
    state.renderTools = renderTools;
  },
  setHolderData(state, holderData) {
    state.holderData = holderData;
  },
  setSelectionsData(state, selectionsData) {
    state.selectionsData = selectionsData;
  },
  isAdvancedMode(state, advancedMode) {
    state.isAdvancedMode = advancedMode;
  },
  popupBeingShown(state, shown) {
    state.globalPlayingPaused = shown;
  },
  setNoTransformsAdded(state, value) {
    state.noTransformsAdded = value;
  },
  setDrawAnchorForTransformId(state, id) {
    state.drawAnchorForTransformId = id;
  },
  viewedPost(state) {
    state.postsViewed += 1;
  },
  setCanInstallApp(state, canInstallApp) {
    state.canInstallApp = canInstallApp;
  },
  setViewingPostId(state, {type,id}) {
    state.viewingPostId[type] = id;
  },
  loadPosts(state, {type,from}) {
    state.viewPosts[type].from = from;
  },
  setStickerSearch(state, search) {
    state.stickerSearch = search;
  },
  setVideoSearch(state, search) {
    state.videoSearch = search;
  },
  setSelectedAddMode(state, mode) {
    state.selectedAddMode = mode;
  },
  setSelectedPack(state, pack) {
    state.selectedPack = pack;
  },
  setSelectedCreateMode(state, mode) {
    state.selectedCreateMode = mode;
  },
  setCurrentActivityId(state, activityId) {
    state.currentActivityId = activityId;
  },
  addRecentlyUsedAsset(state, asset) {
    state.recentlyUsedAssets.unshift(asset);
    state.recentlyUsedAssets = state.recentlyUsedAssets.slice(0,state.recentlyUsedAssets.length);
  },
  addPostedPostId(state, id) {
    state.myPostedPostsIds.push(id);
    state.justPosted = true;
  },
  setFromHot(state, from) {
    state.fromHot = from;
  },
  setFromNew(state, from) {
    state.fromNew = from;
  }
}

const actions = {
}

const createStore = () => {
  const store = new Vuex.Store({
    state,
    getters,
    mutations,
    actions,
    modules:{
    },
    //plugins: process.browser ? [createPersistedState({
      //paths:['tutorials.tutorialState','tutorials.tutorialStats','tutorials.tutorialStateImported']
    //})] : []
  })

  return store;

}

export { createStore };
